/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect } from 'react';
import { StoreContext } from '../../business/Provider';
import {
	LOADING_ON,
	LOADING_OFF,
	GET_ACCESS_SUCCESS,
	POST_ACCESS_SUCCESS,
	GET_ACCESS_ROLE_SUCCESS,
	GET_ACCESS_COMPANIES_SUCCESS,
} from '../../business/constants';
import { generateUrlBase } from '../../utils/utils';
import useApi from '../api';
import { Toast } from '../../components/toast';

const useAccess = () => {
	const context = useContext(StoreContext);
	const { genericApiCall } = useApi();

	const {
		getAccessState,
		getAccessRoleState,
		getAccessCompaniesState,
		dispatchLoading,
		dispatchGetAccess,
		dispatchPostAccess,
		dispatchGetAccessRole,
		dispatchGetAccessCompanies,
	} = context;

	const getAccess = async () => {
		const baseUrl = generateUrlBase('access');
		dispatchLoading({ type: LOADING_ON });
		try {
			const result = await genericApiCall(baseUrl, 'GET', {}, {}, {});
			const payload = result.data;
			if (result.status === 200) {

				const groupedByRole = Object.values(
				payload.results.reduce((acc, item) => {
					const { roleId, roleName, accessId, accessName, grant } = item;

					if (!acc[roleId]) {
						acc[roleId] = {
							roleId,
							roleName,
							accesses: []
						};
					}

					acc[roleId].accesses.push({ accessId, accessName, grant, access:item });
					return acc;
				}, {})
			);

			payload.results = groupedByRole;
				dispatchGetAccess({
					type: GET_ACCESS_SUCCESS,
					payload: payload,
				});
				dispatchLoading({ type: LOADING_OFF });
			}
			return result;
		} catch (error) {
			Toast('warning', 'Error al obtener los accesos', error.message, error);
			dispatchLoading({ type: LOADING_OFF });
		}
	};
	
	const postAccess = async (data) => {
		const baseUrl = generateUrlBase('Access');
		dispatchLoading({ type: LOADING_ON });
		return genericApiCall(baseUrl, 'POST', data, {}, {})
			.then((response) => {
				if (response.status === 200 || response.status === 201) {
					const payload = response.data;
					Toast('success', 'Se ha guardado el acceso de forma correcta');
					dispatchPostAccess({
						type: POST_ACCESS_SUCCESS,
						payload: payload,
					});
					dispatchLoading({ type: LOADING_OFF });
					// Refresh table data and sidebar access
					return Promise.all([getAccess(), getAccessRole()]);
				} else if (response.status === 409) {
					dispatchLoading({ type: LOADING_OFF });
					Toast('info', response.data.detail);
				}
			})
			.catch((error) => {
				Toast('warning', error.message, '', error);
				dispatchLoading({ type: LOADING_OFF });
			});
	};

	const getAccessRole = async () => {
		const baseUrl = generateUrlBase('access/role');
		dispatchLoading({ type: LOADING_ON });
		try {
			const result = await genericApiCall(baseUrl, 'GET', {}, {}, {});
			const payload = result;
			if (result.status === 200) {
				dispatchGetAccessRole({
					type: GET_ACCESS_ROLE_SUCCESS,
					payload: payload,
				});
				dispatchLoading({ type: LOADING_OFF });
			}
			return result;
		} catch (error) {
			Toast('warning', 'Error al obtener los roles', error.message, error);
			dispatchLoading({ type: LOADING_OFF });
		}
	};

	const getAccessCompanies = async () => {
		const baseUrl = generateUrlBase('access/companies');
		dispatchLoading({ type: LOADING_ON });
		try {
			const result = await genericApiCall(baseUrl, 'GET', {}, {}, {});
			const payload = result.data;
			if (result.status === 200) {
				dispatchGetAccessCompanies({
					type: GET_ACCESS_COMPANIES_SUCCESS,
					payload: payload,
				});
				dispatchLoading({ type: LOADING_OFF });
			}
			return result;
		} catch (error) {
			Toast('warning', error.message, '', error);
			dispatchLoading({ type: LOADING_OFF });
		}
	};

	useEffect(() => {
		if (
			getAccessState.access === null &&
			getAccessState.loading === false
		) {
			getAccess();
		}
	}, [getAccessState.access, getAccessRoleState.accessRole]);

	useEffect(() => {
		if (
			getAccessCompaniesState.accessCompanies === null &&
			getAccessCompaniesState.loading === false
		) {
			getAccessCompanies();
		}
	}, [getAccessCompaniesState]);

	return {
		getAccess,
		postAccess,
		getAccessRole,
		getAccessCompanies,
	};
};

export default useAccess;
